import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Card, Tag, Tooltip, Checkbox } from "antd";
import { req_list_pim_self_leave_log } from "../../api";

const LEAVE_TYPE_COLOR = {
  事假: "blue",
  家庭照顧假: "blue",
  病假: "orange",
  生理假: "orange",
  休假: "green",
  遞延休假: "cyan",
  補休: "cyan",
  補休假: "cyan",
  公假: "geekblue",
  公差: "geekblue",
  "公假(行政研習)": "geekblue",
  差假: "geekblue",
  婚假: "red",
  喪假: "red",
  娩假: "magenta",
  產檢假: "magenta",
  陪產檢及陪產假: "magenta",
  流產假: "magenta",
  產前假: "magenta",
  骨髓或器官捐贈假: "magenta",
};

class StaffLeaveApplyLog extends Component {
  state = {
    loading: false,
    deviceWidth: window.innerWidth,
    data: [],
    total: 0,
    filterBuXiu: false,
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    this.init_columns();
    this.api_item_list();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => this.setState({ deviceWidth: window.innerWidth });

  // 遠端數據處理 ///////////////////////////////////////////////
  api_item_list = async () => {
    const { token, userCode } = this.props.user;
    this.setState({ loading: true, data: [] });
    const result = await req_list_pim_self_leave_log('',userCode,'','', token);
    if (result && result.total > 0) {
      //console.log(result);
      this.setState({ data: result.data, total: result.total, loading: false });
    } else {
      this.setState({ data: [], total: 0, loading: false });
    }
  };

  // 格式化工具 ////////////////////////////////////////////////
  convertToWorkDaysPadded = (value) => {
    if (value === null || value === undefined || value === "") return "--";
    const parts = String(value).split(",");
    const days  = parseInt(parts[0], 10) || 0;
    const hours = parseInt(parts[1], 10) || 0;
    if (days === 0 && hours === 0) return "--";
    const d = days.toString().padStart(2, "0");
    const h = hours.toString().padStart(2, "0");
    return `${d}日${h}時`;
  };

  renderStatusTags = (item) => {
    const { IsInvalid, IsDisagree, IsTakeEffect } = item;
    if (IsInvalid) return <Tag color="gray">作廢</Tag>;
    if (IsDisagree) return <Tag color="red">不同意</Tag>;
    if (IsTakeEffect) return <Tag color="green">已生效</Tag>;
    return <Tag color="blue">未生效</Tag>;
  };

  // 欄位設定 /////////////////////////////////////////////////
  init_columns = () => {
    this.columns = [
      {
        title: "假別",
        dataIndex: "LeaveType",
        key: "LeaveType",
        align: "center",
        width: 110,
        render: (text) => (
          <Tag color={LEAVE_TYPE_COLOR[text] || "default"}>{text || "--"}</Tag>
        ),
      },
      {
        title: "狀態",
        key: "status",
        align: "center",
        width: 80,
        render: (item) => this.renderStatusTags(item),
      },
      {
        title: "申請日",
        dataIndex: "ApplyDate",
        key: "ApplyDate",
        align: "center",
        width: 100,
        render: (text) => text ? text.substring(0, 10) : "--",
      },
      {
        title: "開始時間",
        dataIndex: "StartDatetime",
        key: "StartDatetime",
        align: "center",
        width: 140,
        render: (text) => {
          if (!text) return "--";
          const s = text.substring(0, 15).replace("T", "").replace(/-/g, "/");
          const date = s.substring(0, 10);
          const time = s.substring(10);
          return <span>{date} <span style={{ color: "#cf1322" }}>{time}</span></span>;
        },
      },
      {
        title: "結束時間",
        dataIndex: "EndDatetime",
        key: "EndDatetime",
        align: "center",
        width: 140,
        render: (text) => {
          if (!text) return "--";
          const s = text.substring(0, 15).replace("T", "").replace(/-/g, "/");
          const date = s.substring(0, 10);
          const time = s.substring(10);
          return <span>{date} <span style={{ color: "#cf1322" }}>{time}</span></span>;
        },
      },
      {
        title: "時數",
        dataIndex: "LeaveDayHours",
        key: "LeaveDayHours",
        align: "center",
        width: 80,
        render: (val) => {
          const formatted = this.convertToWorkDaysPadded(val);
          const isPositive = formatted !== "--";
          return (
            <span style={isPositive ? { color: "#1565c0", fontWeight: "bold" } : {}}>
              {formatted}
            </span>
          );
        },
      },
      // {
      //   title: "部門",
      //   dataIndex: "DeptName",
      //   key: "DeptName",
      //   align: "center",
      //   width: 100,
      //   render: (text) => text || "--",
      // },
      {
        title: "申請人",
        key: "staff",
        align: "center",
        width: 110,
        render: (item) => (
          <span>
            <span style={{ color: "#1565c0", marginRight: 4 }}>{item.StaffCode}</span>
            {item.StaffName}
          </span>
        ),
      },
      {
        title: "原因",
        dataIndex: "Reason",
        key: "Reason",
        ellipsis: true,
        render: (text) =>
          text ? (
            <Tooltip title={text}>
              <span>{text}</span>
            </Tooltip>
          ) : (
            "--"
          ),
      },
    ];
  };

  render() {
    const { loading, data, total, deviceWidth, filterBuXiu } = this.state;
    const isMobile = deviceWidth < 768;
    const displayData = filterBuXiu
      ? data.filter((d) => d.LeaveType === "補休" || d.LeaveType === "補休假")
      : data;

    return (
      <Card
        title="請假申請記錄"
        size="small"
        extra={
          <span style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <Checkbox
              checked={filterBuXiu}
              onChange={(e) => this.setState({ filterBuXiu: e.target.checked })}
            >
              補休
            </Checkbox>
            <span style={{ color: "#888", fontSize: 12 }}>共 {total} 筆</span>
          </span>
        }
      >
        <Table
          rowKey="Id"
          size={isMobile ? "small" : "middle"}
          loading={loading}
          columns={this.columns}
          dataSource={displayData}
          scroll={{ x: 900 }}
          pagination={{
            pageSize: 15,
            showSizeChanger: false,
            showTotal: (t) => `共 ${t} 筆`,
          }}
          rowClassName={(record) => {
            if (record.IsInvalid)  return "row-invalid";
            if (record.IsDisagree) return "row-disagree";
            return "";
          }}
        />
        <style>{`
          .row-invalid td  { color: #bbb !important; text-decoration: line-through; }
          .row-disagree td { color: #cf1322 !important; }
        `}</style>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({ user: state.user });
export default connect(mapStateToProps)(StaffLeaveApplyLog);
